import React from 'react'
import { cn } from '../../lib/utils'

// @ts-expect-error - InputProps extends React.InputHTMLAttributes
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  wrapperClassName?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, wrapperClassName, leftIcon, size = 'md', ...props }, ref) => {
    const sizes = {
      sm: 'h-8 text-sm',
      md: 'h-10',
      lg: 'h-12 text-base',
    }

    return (
      <div className={cn('relative', wrapperClassName)}>
        {leftIcon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground/50">{leftIcon}</span>
        )}
        <input
          ref={ref}
          className={cn(
            'w-full rounded-lg border border-black/10 bg-white text-foreground placeholder:text-foreground/50 focus:outline-none focus:ring-2 focus:ring-brand-500',
            sizes[size],
            leftIcon ? 'pl-10 pr-3' : 'px-3',
            className,
          )}
          {...props}
        />
      </div>
    )
  }
)

Input.displayName = 'Input'

export { Input }
export default Input
